<div class="flex items-start gap-2 text-white p-3">
  @if (type === 'share-message') {
    <div>
      <mat-icon class="!text-[20px] !w-[20px] !h-[20px]">help</mat-icon>
    </div>
    <div class="text-[16px] leading-6">
      <p>此訊息為「被分享者」會看到的訊息，在使用分享訊息前，請確認您已</p>
      <p>完成「串接 LINE Login」與「開啟 Share Target Picker」</p>
      <p>按鈕的類型為「分享訊息」時，訊息需符合以下所有條件才能被選取：</p>
      <ul>
        <li>1. 卡片、海報的按鈕的類型不包含說話</li>
        <li>2. Flex的按鈕的類型不包含訊息、回傳訊息</li>
        <li>3. 訊息的數量不超過5個訊息內容</li>
        <li>4. 訊息不包含海報格式</li>
        <li>5. 訊息不包含來自圖像編輯器的卡片、海報、圖片</li>
      </ul>
    </div>
  }
  @if (type === 'share-add-friend') {
    <div>
      <mat-icon class="!text-[20px] !w-[20px] !h-[20px]">help</mat-icon>
    </div>
    <div class="text-[16px] leading-6">
      <p>此訊息為「被分享者」會看到的訊息，在使用分享訊息前，請確認您已</p>
      <p>完成「串接 LINE Login」與「開啟 Share Target Picker」</p>
      <p>按鈕的類型為「分享訊息並邀請好友加入LINE官方帳號」時，訊息需符</p>
      <p>合以下所有條件才能被選取：</p>
      <ul>
        <li>1. 訊息需同時有「分享」與「加入 LINE 官方帳號」2顆按鈕</li>
        <li>2. 按鈕的類型沒有「分享訊息並邀請好友加入LINE官方帳號」</li>
        <li>3. 卡片、海報的按鈕的類型不包含說話</li>
        <li>4. Flex的按鈕的類型不包含訊息、回傳訊息</li>
        <li>5. 訊息的數量不超過5個訊息內容</li>
        <li>6. 訊息不包含海報格式</li>
        <li>7. 訊息不包含來自圖像編輯器的卡片、海報、圖片</li>
      </ul>
    </div>
  }
</div>
